import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './icons';
import { groupedSections, sectionPath } from './sections';
import './VMSidebar.css';

const isAdminOnly = (s) => s.roles.length === 1 && s.roles[0] === 'admin';

const statusClass = (status) => (status === 'running' ? 'running' : status === 'stopped' ? 'stopped' : 'other');

function VMSidebar({
  vmid, role, active, counts = {}, collapsed = false, onToggleCollapsed, protection = null,
  vm = null, statusLabel = '',
}) {
  const groups = groupedSections(role);

  const backLink = (
    <Link to="/" className="vmd-back">
      <span className="vmd-nav-icon"><Icon name="back" size={14} /></span>
      <span className="vmd-nav-label">Minhas VMs</span>
    </Link>
  );

  const renderItem = (s, chip) => {
    const count = counts[s.slug];
    const isActive = s.slug === active;
    return (
      <Link
        key={s.slug}
        to={sectionPath(vmid, s.slug)}
        className={`${chip ? 'vmd-chip' : 'vmd-nav-item'}${isActive ? ' active' : ''}`}
        aria-current={isActive ? 'page' : undefined}
        title={s.label}
      >
        <span className="vmd-nav-icon"><Icon name={s.icon} size={chip ? 14 : 18} /></span>
        <span className="vmd-nav-label">{s.label}</span>
        {!chip && isAdminOnly(s) && <span className="vmd-tag">admin</span>}
        {count != null && count !== 0 && <span className="vmd-count">{count}</span>}
      </Link>
    );
  };

  const showProtection = role === 'admin' && protection;

  return (
    <>
      <nav className={`vmd-sidebar${collapsed ? ' collapsed' : ''}`} aria-label="Seções da VM">
        {vm && (
          <div className="vmd-sidebar-head">
            {backLink}
            <div className="vmd-vm-name" title={vm.name}>{vm.name}</div>
            <div className="vmd-vm-meta">
              <span className={`vmd-status ${statusClass(vm.status)}`} title={statusLabel || vm.status}>
                <span className="vmd-status-dot" />
                <span className="vmd-status-label">{statusLabel || vm.status}</span>
              </span>
              <span className="vmd-tag">VMID {vm.vmid}</span>
            </div>
          </div>
        )}
        {groups.map(g => (
          <div key={g.id} className="vmd-nav-group">
            <div className="vmd-nav-group-title">{g.label}</div>
            {g.items.map(s => renderItem(s, false))}
            {g.id === 'protecao' && showProtection && (
              <button
                type="button"
                role="switch"
                aria-checked={!!protection.value}
                aria-label="Proteção da VM"
                className={`vmd-nav-item vmd-switch${protection.value ? ' on' : ''}`}
                onClick={protection.onToggle}
                disabled={protection.toggling}
                title={protection.value ? 'Desativar proteção da VM' : 'Ativar proteção da VM'}
              >
                <span className="vmd-nav-icon"><Icon name="shield" size={18} /></span>
                <span className="vmd-nav-label">Proteção da VM</span>
                <span className="vmd-tag">admin</span>
                <span className="vmd-switch-state">{protection.toggling ? '…' : protection.value ? 'ON' : 'OFF'}</span>
              </button>
            )}
          </div>
        ))}
        {onToggleCollapsed && (
          <button
            type="button"
            className="vmd-nav-item vmd-collapse"
            onClick={onToggleCollapsed}
            aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
            aria-pressed={collapsed}
          >
            <span className="vmd-nav-icon"><Icon name="sidebar" size={18} /></span>
            <span className="vmd-nav-label">Recolher menu</span>
          </button>
        )}
      </nav>
      {vm && (
        <div className="vmd-mobile-head">
          {backLink}
        </div>
      )}
      <nav className="vmd-chips" aria-label="Seções da VM (compacto)">
        {groups.flatMap(g => g.items).map(s => renderItem(s, true))}
        {showProtection && (
          <button
            type="button"
            role="switch"
            aria-checked={!!protection.value}
            aria-label="Proteção da VM"
            className={`vmd-chip vmd-switch${protection.value ? ' on' : ''}`}
            onClick={protection.onToggle}
            disabled={protection.toggling}
            title={protection.value ? 'Desativar proteção da VM' : 'Ativar proteção da VM'}
          >
            <span className="vmd-nav-icon"><Icon name="shield" size={14} /></span>
            <span className="vmd-nav-label">Proteção</span>
            <span className="vmd-switch-state">{protection.toggling ? '…' : protection.value ? 'ON' : 'OFF'}</span>
          </button>
        )}
      </nav>
    </>
  );
}

export default VMSidebar;
